import React from 'react';
import { Link } from 'react-router-dom';
import iconReversed from '../assets/brand/icon-reversed.svg';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#0F2942' }} data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">

          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3 mb-4" data-testid="footer-logo">
              <img src={iconReversed} alt="" aria-hidden="true" className="h-10 w-auto" width="42" height="40" />
              <h2
                className="text-3xl font-light tracking-tight text-white mb-0"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                CultureCareers
              </h2>
            </Link>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: 'rgba(240, 235, 226, 0.5)' }}>
              India&rsquo;s first recruitment platform for the creative industries. Curated jobs, vetted talent, and artist services.
            </p>

            {/* Social */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://instagram.com/culturecareersworld"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-100"
                style={{ opacity: 0.5, color: '#FFFFFF' }}
                aria-label="Instagram"
                data-testid="social-instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a
                href="https://www.linkedin.com/company/culturecareersindia/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-100"
                style={{ opacity: 0.5, color: '#FFFFFF' }}
                aria-label="LinkedIn"
                data-testid="social-linkedin"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>

          {/* Navigation — single, consolidated Explore column */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] font-medium mb-5" style={{ color: '#D4820A' }}>
              Explore
            </h4>
            <ul className="space-y-3">
              <li><Link to="/browse" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-browse">Browse Jobs</Link></li>
              <li><Link to="/post-job" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-post-job">Post a Job</Link></li>
              <li><Link to="/talent" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-talent">Join Talent Network</Link></li>
              <li><Link to="/about" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-about">About Us</Link></li>
              <li><Link to="/services" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-services">Services</Link></li>
              <li><a href="mailto:partnerships@culturecareers.org" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-contact">Contact</a></li>
            </ul>
          </div>

          {/* Reading Resources */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] font-medium mb-5" style={{ color: '#D4820A' }}>
              Reading Resources
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://substack.com/@krishnashuklaofficial?utm_source=user-menu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm transition-colors hover:text-white"
                  style={{ color: 'rgba(240, 235, 226, 0.5)' }}
                  data-testid="footer-reading-substack"
                >
                  Founder's Substack
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] font-medium mb-5" style={{ color: '#D4820A' }}>
              Get in Touch
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:partnerships@culturecareers.org" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-email">
                  partnerships@culturecareers.org
                </a>
              </li>
              <li>
                <a href="tel:+918484834978" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-phone">
                  +91 84848 34978
                </a>
              </li>
              <li className="pt-1">
                <address className="not-italic text-sm leading-relaxed" style={{ color: 'rgba(240, 235, 226, 0.5)' }} data-testid="footer-address">
                  38 Ashwini Layout,<br />
                  2nd Main Road, Koramangala,<br />
                  Bangalore 560047
                </address>
              </li>
            </ul>
            <div className="mt-6">
              <Link
                to="/post-job"
                className="inline-flex items-center px-5 py-2.5 text-xs font-medium transition-all hover:opacity-90"
                style={{ backgroundColor: '#D4820A', color: '#0F2942', borderRadius: '999px' }}
                data-testid="footer-cta"
              >
                Post a Job
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="px-6 md:px-12 lg:px-24 py-6" style={{ borderTop: '1px solid rgba(240, 235, 226, 0.08)' }}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: 'rgba(240, 235, 226, 0.3)' }}>
            &copy; {year} CultureCareers. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: 'rgba(240, 235, 226, 0.3)' }}>
            Curated with care for India&rsquo;s creative community.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
